// extracted by mini-css-extract-plugin
export default {"spin":"FileMessage_spin__403nk","error":"FileMessage_error__I122J","link":"FileMessage_link__4-y0f","size":"FileMessage_size__b3L2a"};